"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var Cookie = require("js-cookie");
var service_1 = require("./service");
var isLegalFun = function () {
    return Cookie.get("clientUserType") === "legal";
};
var FormItem = next_1.Form.Item;
var formItemLayout = {
    labelCol: {
        fixedSpan: 10,
    },
    wrapperCol: {
        span: 14,
    },
};
var GLOBAL_VARIABLE = {
    countTime: 60,
    intervalTime: 1000,
};
var errStatus = ["aborted", "failed", "expired"];
var setin = "";
var Register = function (props) {
    var task = props.task;
    var isLegal = isLegalFun();
    var isPerson = !isLegal;
    var _a = react_1.useState(""), phone = _a[0], setPhone = _a[1];
    var _b = react_1.useState(false), showCount = _b[0], setShowCount = _b[1];
    var _c = react_1.useState([]), cardType = _c[0], setCardType = _c[1];
    var _d = react_1.useState(""), activeCard = _d[0], setActiveCard = _d[1];
    var _e = react_1.useState(GLOBAL_VARIABLE.countTime), time = _e[0], setTime = _e[1];
    var _f = react_1.useState(""), taskId = _f[0], setTaskId = _f[1];
    var _g = react_1.useState(false), agree = _g[0], setAgree = _g[1];
    var interval = null;
    react_1.useEffect(function () {
        getCardType();
    }, []);
    var getCardType = function () { return __awaiter(_this, void 0, void 0, function () {
        var info, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, service_1.getIdCardInfo()];
                case 1:
                    info = _a.sent();
                    setCardType(info);
                    if (info && info[0]) {
                        setActiveCard(info[0].value);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var changeCardType = function (value) {
        setActiveCard(value);
    };
    var sendVerifyCode = function () { return __awaiter(_this, void 0, void 0, function () {
        var param, res, _a, _b, success, _c, errorMsg, error_2;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    if (!phone) {
                        next_1.Message.error("手机号不能为空");
                        return [2 /*return*/];
                    }
                    param = {
                        mobilePhone: phone,
                    };
                    /** 后端的这两种类型入参居然不一样 */
                    if (isLegal) {
                        param.action = "5"; // 手机端的唯一设备信息
                    }
                    else {
                        param.checkCode = "123456";
                    }
                    return [4 /*yield*/, service_1._uc_verify_sendCodeUsingPost(param)];
                case 1:
                    res = _d.sent();
                    _a = res || {}, _b = _a.success, success = _b === void 0 ? false : _b, _c = _a.errorMsg, errorMsg = _c === void 0 ? "" : _c;
                    if (success) {
                        setShowCount(true);
                        countTime();
                    }
                    else {
                        next_1.Message.error(errorMsg);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _d.sent();
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var countTime = function () {
        interval = setInterval(function () {
            if (time <= 0) {
                clearInterval(interval);
                setShowCount(false);
                setTime(GLOBAL_VARIABLE.countTime);
            }
            else {
                setTime(time - 1);
            }
        }, GLOBAL_VARIABLE.intervalTime);
    };
    var doLegalLogin = function (data) {
        if (data === void 0) { data = {}; }
        return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                try {
                    params = {
                        loginType: "offline",
                        identifier: data.identifier,
                        credential: __assign({ loginType: "1", govAuthCode: Cookie.get("govAuthCode") }, data),
                    };
                    service_1.doLogin(params, doRegisterSuccess, null);
                }
                catch (error) {
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    var doLegalRegister = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var params, res, _a, _b, success, _c, errorMsg, _d, data, error_3;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 5, , 6]);
                    params = __assign({ frType: "1" }, values);
                    return [4 /*yield*/, service_1._uc_account_legalRegisterUsingPost(params)];
                case 1:
                    res = _e.sent();
                    _a = res || {}, _b = _a.success, success = _b === void 0 ? false : _b, _c = _a.errorMsg, errorMsg = _c === void 0 ? "" : _c, _d = _a.data, data = _d === void 0 ? {} : _d;
                    if (!(success && isLegal)) return [3 /*break*/, 3];
                    // 法人注册完需去登录，种cookie
                    return [4 /*yield*/, doLegalLogin(data.extResult)];
                case 2:
                    // 法人注册完需去登录，种cookie
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (success) {
                        doRegisterSuccess();
                    }
                    else {
                        next_1.Message.error(errorMsg);
                    }
                    _e.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_3 = _e.sent();
                    throw error_3;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var addPersonalInfo = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var params, res, _a, _b, success, _c, errorMsg, _d, data, error_4;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    params = {
                        activegbaccount: true,
                        code: values.code,
                        mobilephone: phone,
                    };
                    return [4 /*yield*/, service_1._app_api_userFacePass_addUserInfoUsingPost(params)];
                case 1:
                    res = _e.sent();
                    _a = res || {}, _b = _a.success, success = _b === void 0 ? false : _b, _c = _a.errorMsg, errorMsg = _c === void 0 ? "" : _c, _d = _a.data, data = _d === void 0 ? {} : _d;
                    if (success && data && data.result === "0") {
                        doRegisterSuccess();
                    }
                    else {
                        next_1.Message.error(errorMsg);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _e.sent();
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (values) {
        if (values === void 0) { values = {}; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (Object.keys(values).length === 0) {
                        return [2 /*return*/];
                    }
                    if (isLegal) {
                        doLegalRegister(values);
                    }
                    else {
                        addPersonalInfo(values);
                    }
                }
                catch (error) {
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    var doRegisterSuccess = function () {
        next_1.Message.success("注册成功");
        if (props.goto) {
            window.location.href = props.goto;
        }
    };
    react_1.useEffect(function () {
        if (taskId) {
            queryRegisterTask();
        }
    }, [taskId]);
    var queryRegisterTask = function () {
        setin = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, task.queryTask("webViewDisplay", taskId)];
                    case 1:
                        result = _a.sent();
                        if (result && result.list && result.list[0]) {
                            status = result.list[0].status;
                            if (status === "success") {
                                clearInterval(setin);
                                setAgree(true);
                            }
                            if (errStatus.indexOf(status) > -1) {
                                clearInterval(setin);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); }, GLOBAL_VARIABLE.intervalTime);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "formLable" }, "\u5F53\u524D\u672A\u67E5\u8BE2\u5230\u8BE5\u8BC1\u4EF6\u5BF9\u5E94\u7684\u8D26\u6237\uFF0C\u8BF7\u6CE8\u518C\u65B0\u8D26\u53F7"),
        React.createElement(next_1.Form, __assign({}, formItemLayout),
            isLegal && React.createElement("div", { className: "itemLable" }, "\u4F01\u4E1A/\u673A\u6784\u4FE1\u606F"),
            isLegal && (React.createElement(FormItem, { label: "\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801:", required: true, requiredMessage: "\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "unifiedSocialId", placeholder: "\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801", size: "large", onChange: function (val) { } }))),
            isLegal && (React.createElement(FormItem, { label: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u59D3\u540D:", required: true, requiredMessage: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "principal", onChange: function (value) { }, placeholder: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u59D3\u540D", size: "large" }))),
            isLegal && (React.createElement(FormItem, { label: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u8EAB\u4EFD\u8BC1\u53F7:", required: true, requiredMessage: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u8EAB\u4EFD\u8BC1\u53F7\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "idNo", onChange: function (value) { }, placeholder: "\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u8EAB\u4EFD\u8BC1\u53F7", size: "large" }))),
            isLegal && React.createElement("div", { className: "itemLable" }, "\u7ECF\u529E\u4EBA\u4FE1\u606F"),
            React.createElement(FormItem, { label: "\u59D3\u540D:", required: true, requiredMessage: "\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "attnName", onChange: function (value) { }, placeholder: "\u59D3\u540D", size: "large" })),
            isPerson && (React.createElement(FormItem, { label: "\u8BC1\u4EF6\u7C7B\u578B:", required: true, requiredMessage: "\u8BC1\u4EF6\u7C7B\u578B\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Select, { dataSource: cardType, value: activeCard, onChange: changeCardType, style: { width: "100%" } }))),
            isLegal ? (React.createElement(FormItem, { label: "\u8EAB\u4EFD\u8BC1\u53F7:", required: true, requiredMessage: "\u8EAB\u4EFD\u8BC1\u53F7\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "attnIdNo", onChange: function (value) { }, placeholder: "\u8EAB\u4EFD\u8BC1\u53F7", size: "large" }))) : null,
            isPerson ? (React.createElement(FormItem, { label: "\u8BC1\u4EF6\u53F7:", required: true, requiredMessage: "\u8BC1\u4EF6\u53F7\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "attnIdNo", onChange: function (value) { }, placeholder: "\u8BC1\u4EF6\u53F7", size: "large" }))) : null,
            React.createElement(FormItem, { label: "\u624B\u673A\u53F7:", required: true, requiredMessage: "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "attnPhone", onChange: function (value) {
                        setPhone(value);
                    }, placeholder: "\u624B\u673A\u53F7", size: "large" })),
            React.createElement(FormItem, { label: "\u9A8C\u8BC1\u7801:", required: true, requiredMessage: "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "code", placeholder: "\u8BF7\u8F93\u5165", size: "large", innerAfter: React.createElement(next_1.Form.Submit, { text: true, size: "small", type: "primary", disabled: showCount, validate: ["phone"], onClick: sendVerifyCode, style: { marginRight: 10 } }, showCount ? time + "s\u540E\u53EF\u91CD\u65B0\u53D1\u9001\u77ED\u4FE1" : "发送协议及验证码") })),
            React.createElement(FormItem, { label: " " },
                React.createElement(next_1.Form.Submit, { type: "primary", validate: true, onClick: handleSubmit }, "\u6CE8\u518C")))));
};
exports.default = Register;
